/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsLicenseDetails {
    getFixupPrototypeFunction() { return AppSecopsLicenseDetails.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsLicenseDetails>): AppSecopsLicenseDetails {
        let obj = Object.assign(new AppSecopsLicenseDetails(), model);
        AppSecopsLicenseDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsLicenseDetails>): AppSecopsLicenseDetails {
        if (!model) return null;
        return AppSecopsLicenseDetails.newInstance(<AppSecopsLicenseDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsLicenseDetails) {
        if (!obj) return;

        models.AppSecopsLicenseDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsLicenseDetails): boolean {
        Object.setPrototypeOf(obj, AppSecopsLicenseDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Unique identifier for the license
     */
    name: string;

    /**
     * Terms of the license
     */
    terms: string;

}
